// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/bancoIntegracao/providers/index.ts
//
//  REGISTRY dos provedores de integração bancária. Resolve qual provider usar a
//  partir da configuração de integração da conta corrente
//  (ContaCorrenteIntegracao.tipoIntegracao). Para somar um banco: implemente o
//  provider e registre-o aqui — nenhuma tela muda.
//
//  tipoIntegracao: 0 = ACBr arquivo (sem API), 1 = Inter API, 2 = outro API,
//  3 = Sicoob API.
// ════════════════════════════════════════════════════════════════════════════

import type { ContaCorrenteIntegracao } from '@/features/financeiro/types';
import type { BancoIntegracaoProvider } from '../provider';
import { interProvider } from './interProvider';
import { sicoobProvider } from './sicoobProvider';

/// Mapeia o código de integração da conta → provider. Estenda aqui.
const PROVIDERS_POR_TIPO_INTEGRACAO: Record<number, BancoIntegracaoProvider> = {
  1: interProvider,
  3: sicoobProvider,
};

/// Todos os providers conhecidos (para telas de catálogo/admin, se necessário).
export const PROVIDERS_DISPONIVEIS: BancoIntegracaoProvider[] = [interProvider, sicoobProvider];

/// Resolve o provider de uma conta a partir da sua integração. Null = a conta
/// não tem integração bancária por API suportada (ex.: só ACBr/arquivo).
export function resolveProvider(
  integracao?: ContaCorrenteIntegracao | null,
): BancoIntegracaoProvider | null {
  if (!integracao || integracao.tipoIntegracao == null) return null;
  return PROVIDERS_POR_TIPO_INTEGRACAO[integracao.tipoIntegracao] ?? null;
}
